"use client"

import { createContext, useContext, useEffect, useState } from "react"
import en from "./en.js"
import ru from "./ru.js"
import pl from "./pl.js"
import uk from "./uk.js"
import es from "./es.js"
import de from "./de.js"
import fr from "./fr.js"
import it from "./it.js"

const LanguageContext = createContext()

// Переводы
const translations = {
  en,
  ru,
  pl,
  uk,
  es,
  de,
  fr,
  it
}

// Определение языка браузера
const getBrowserLanguage = () => {
  const browserLang = navigator.language || navigator.languages[0]

  if (browserLang.startsWith("ru")) return "ru"
  if (browserLang.startsWith("pl")) return "pl"
  if (browserLang.startsWith("uk")) return "uk"
  if (browserLang.startsWith("es")) return "es"
  if (browserLang.startsWith("de")) return "de"
  if (browserLang.startsWith("fr")) return "fr"
  if (browserLang.startsWith("it")) return "it"
  return "en" // по умолчанию английский
}

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    // Проверяем сохраненный язык или определяем по браузеру
    const savedLang = localStorage.getItem("language")
    return savedLang || getBrowserLanguage()
  })

  useEffect(() => {
    localStorage.setItem("language", language)
  }, [language])

  const t = (key) => {

    const currentTranslations = translations[language]
    if (!currentTranslations) {
      return key
    }

    const keys = key.split("/")
    let value = currentTranslations

    for (const k of keys) {
      value = value?.[k]
    }

    return value || key
  }

  const changeLanguage = (newLanguage) => {
    if (translations[newLanguage]) {
      setLanguage(newLanguage)
    }
  }

  const value = {
    language,
    changeLanguage,
    t,
    availableLanguages: [
      { code: "en", name: "English"},
      { code: "ru", name: "Русский"},
      { code: "pl", name: "Polski"},
      { code: "uk", name: "Українська"},
      { code: "es", name: "Español"},
      { code: "de", name: "Deutsch"},
      { code: "fr", name: "Français"},
      { code: "it", name: "Italiano"}
    ],
  }

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
}

export function useLanguage() {
  const context = useContext(LanguageContext)
  if (context === undefined) {
    throw new Error("useLanguage must be used within a LanguageProvider")
  }
  return context
}
